import axiosInstance from "@/middlewares/Routing.middleware";

export async function GetAll(url: string) {
  return await axiosInstance.get(`${url}all`);
}
